import { IconPlus } from '@tabler/icons-react';
import { FC } from 'react';

import { Conversation } from '../../types/chat';
import { ChatSummary } from '../../api/chat';

interface Props {
  selectedChat: ChatSummary;
  onNewConversation: () => void;
}

export const Navbar: FC<Props> = ({
  selectedChat,
  onNewConversation,
}) => {
  return (
    <nav className="flex w-full justify-between bg-[#202123] py-3 px-4">
      <div className="mr-4"></div>

      <div className="overflow-hidden text-ellipsis whitespace-nowrap">
        {selectedChat.title}
      </div>

      <IconPlus
        className="cursor-pointer hover:text-neutral-400 mr-8"
        onClick={onNewConversation}
      />
    </nav>
  );
};
